import { render } from "./attendance.vue?vue&type=template&id=ddb3d6be&scoped=true"
import script from "./attendance.vue?vue&type=script&lang=js"
export * from "./attendance.vue?vue&type=script&lang=js"

import "./attendance.vue?vue&type=style&index=0&id=ddb3d6be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddb3d6be"]])

export default __exports__